import { IonPage, IonRouterOutlet } from "@ionic/react";
import { Redirect, Route, Switch } from "react-router";
import GlobalInitializeData from "../GlobalInitializeData";
import isAuthenticated from "global/utils/isAuthenticated";
import listRoutesSegundoFactor from "./listRoutes";
import { SegundoFactorProvider } from "../context/provider";
import PaginaNoEncontrada from "../pages/PaginaNoEncontrada/PaginaNoEncontrada";

const RouterSegundoFactor = () => {
  let path = window.location.pathname;
  return (
    <SegundoFactorProvider>
      <GlobalInitializeData>
        <IonPage>
          <IonRouterOutlet>
            <Switch>
              {listRoutesSegundoFactor.map((route, key) => {
                if (
                  route.path.toLocaleLowerCase() === path.toLocaleLowerCase()
                ) {
                  document.title = route.title;
                }
                return (
                  <Route
                    path={route.path}
                    key={key}
                    render={(props) =>
                      route.needsAuth && !isAuthenticated() && path !== "/" ? (
                        <Redirect to="/" />
                      ) : (
                        <route.component {...props} />
                      )
                    }
                    exact
                  />
                );
              })}
              <Route path="/" component={PaginaNoEncontrada} />
            </Switch>
          </IonRouterOutlet>
        </IonPage>
      </GlobalInitializeData>
    </SegundoFactorProvider>
  );
};

export default RouterSegundoFactor;
